<template>
  <v-dialog v-model="dialog" persistent="persistent" max-width="1000px">
    <v-card grid-list-md="grid-list-md">
      <v-toolbar dark="dark" color="primary">
        <v-toolbar-title>{{ $t("pageHeader.editStore") }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text v-if="!isLoading">
        <v-container grid-list-lg>
          <v-layout row>
            <v-flex xs12>
              <div>Location Information</div>
              <v-layout row wrap>
                <v-flex xs12 sm6="sm6">
                  <v-text-field
                    autofocus="autofocus"
                    v-model="editLocation.businessName"
                    :error-messages="businessNameErrors"
                    label="Business Name"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm6="sm6">
                  <Address @addressSubmit="setAddress" :initAddress="editLocation.address">
                  </Address>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs12 sm3="sm3">
                  <v-text-field
                    v-model="editLocation.city"
                    :error-messages="cityErrors"
                    label="City"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm3="sm3">
                  <v-select
                    :items="states"
                    :label="$t('labels.state')"
                    item-text="stateName"
                    item-value="stateID"
                    v-model="editLocation.stateID"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm3="sm3">
                  <v-text-field
                    v-model="editLocation.zipCode"
                    :error-messages="zipCodeErrors"
                    label="Zip code"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm3="sm3">
                  <v-text-field
                    v-model="editLocation.businessPhone"
                    :error-messages="businessPhoneErrors"
                    label="Phone Number"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm3="sm3">
                  <v-text-field v-model="editLocation.cellPhone" label="Cell Number">
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm4="sm4">
                  <v-text-field v-model="editLocation.businessEmail" label="Email Address">
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm5="sm5">
                  <v-text-field v-model="editLocation.webSite" label="Web Site"> </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm4="sm4">
                  <v-select
                    :items="comboBoxByID(13).ComboBoxDetails"
                    :label="$t('labels.whereDidYouFindUs')"
                    item-text="selector"
                    item-value="id"
                    v-model="editLocation.findUsID"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm4="sm4">
                  <v-select
                    :items="comboBoxByID(12).ComboBoxDetails"
                    :label="$t('labels.businessType')"
                    item-text="selector"
                    item-value="id"
                    v-model="editLocation.businessTypeID"
                  >
                  </v-select>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer> </v-spacer>
        <v-btn color="blue darken-1" text @click="close">Close</v-btn>
        <v-btn color="blue darken-1" dark="dark" @click="updateStore">Update</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import locationService from "../service.js";
import Address from "../../Global/components/Address";
const { validationMixin } = require("vuelidate");
const { required, minLength, minValue } = require("vuelidate/lib/validators");

export default {
  props: {
    editDialog: {
      default: false
    }
  },
  name: "edit-store",
  data() {
    return {
      dueDateMenu: false,
      isLoading: true,
      dialog: false,
      editLocation: null
    };
  },
  components: {
    Address
  },
  mixins: [validationMixin],
  validations: {
    editLocation: {
      businessName: {
        required,
        minLength: minLength(4)
      },
      address: {
        required,
        minLength: minLength(5)
      },
      city: {
        required,
        minLength: minLength(2)
      },
      zipCode: {
        required,
        minLength: minLength(5)
      },
      businessPhone: {
        required,
        minLength: minLength(10)
      }
    }
  },
  computed: {
    ...mapGetters("global", ["comboBoxByID", "currentUser", "states"]),
    ...mapGetters("location", ["location"]),
    businessNameErrors() {
      const errors = [];
      if (!this.$v.editLocation.businessName.$dirty) return errors;
      if (!this.$v.editLocation.businessName.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.editLocation.businessName.minLength)
        errors.push(this.$t("validations.fieldMustbeatLeast4ChrLong"));
      return errors;
    },
    addressErrors() {
      const errors = [];
      if (!this.$v.editLocation.address.$dirty) return errors;
      if (!this.$v.editLocation.address.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.editLocation.address.minLength)
        errors.push("Field must be at least 10 characters long");
      return errors;
    },
    cityErrors() {
      const errors = [];
      if (!this.$v.editLocation.city.$dirty) return errors;
      if (!this.$v.editLocation.city.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.editLocation.city.minLength)
        errors.push("Field must be at least 10 characters long");
      return errors;
    },
    zipCodeErrors() {
      const errors = [];
      if (!this.$v.editLocation.zipCode.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.editLocation.zipCode.minLength)
        errors.push("Field must be at least 10 characters long");
      return errors;
    },
    businessPhoneErrors() {
      const errors = [];
      if (!this.$v.editLocation.businessPhone.$dirty) return errors;
      if (!this.$v.editLocation.businessPhone.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.editLocation.businessPhone.minLength)
        errors.push("Field must be at least 10 characters long");
      return errors;
    },
    stripeIDErrors() {
      const errors = [];
      if (!this.$v.editLocation.stripeID.$dirty) return errors;
      if (!this.$v.editLocation.stripeID.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.editLocation.stripeID.minLength)
        errors.push("Field must be at least 10 characters long");
      return errors;
    },
    smsRateFeeErrors() {
      const errors = [];
      if (!this.$v.editLocation.smsRate.$dirty) return errors;
      if (!this.$v.editLocation.smsRate.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
    mmsRateFeeErrors() {
      const errors = [];
      if (!this.$v.editLocation.mmsRate.$dirty) return errors;
      if (!this.$v.editLocation.mmsRate.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    }
  },
  watch: {
    editDialog(val) {
      this.dialog = val;
      if (val) {
        this.editLocation = _.clone(this.location);
        this.isLoading = false;
      }
    }
  },
  methods: {
    ...mapActions("location", ["setLocation"]),
    setAddress(val) {
      this.editLocationzipCode = val.zipCode;
      this.editLocation.city = val.city;
      this.editLocation.country = val.country;
      this.editLocation.address = val.address;
      this.editLocation.latitude = val.latitude;
      this.editLocation.longitude = val.longitude;
      this.editLocation.stateID = val.stateID;
    },
    updateStore() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          })
          .fire({
            type: "error",
            title: this.$t("toastMessage.text.invalidFields")
          });
      } else {
        let editData = {
          businessName: this.editLocation.businessName,
          address: this.editLocation.address,
          city: this.editLocation.city,
          stateID: this.editLocation.stateID,
          zipCode: this.editLocation.zipCode,
          businessPhone: this.editLocation.businessPhone,
          cellPhone: this.editLocation.cellPhone,
          businessEmail: this.editLocation.businessEmail,
          webSite: this.editLocation.webSite,
          findUsID: this.editLocation.findUsID,
          businessTypeID: this.editLocation.businessTypeID,
          longitude: this.editLocation.longitude,
          latitude: this.editLocation.latitude
        };
        return locationService
          .updateStore(this.editLocation.storeID, editData)
          .then(result => {
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
              })
              .fire({
                type: "success",
                title: "Update Successfully"
              });
            this.close();
            this.setLocation(this.editLocation.storeID);
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped></style>
